module.exports = __webpack_public_path__ + "static/media/detail_0027_t.134cbee6.jpg";